"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyDealerConfigurationServiceV1Impl = void 0;
class MyDealerConfigurationServiceV1Impl {
    constructor(options, historyService) {
        this.options = options;
        this.listeners = [];
        const initialPathName = historyService.rootHistory.location.pathname;
        this.currentPageOwner = this.options.getDealerPageOwner(initialPathName);
        historyService.rootHistory.listen(() => {
            const currentPathName = historyService.rootHistory.location.pathname;
            const pageOwner = this.options.getDealerPageOwner(currentPathName);
            if (this.currentPageOwner !== pageOwner) {
                this.currentPageOwner = pageOwner;
                this.listeners.forEach((listener) => listener(this.currentPageOwner));
            }
        });
        this.preview = Boolean(options.preview);
        if (typeof window !== 'undefined' &&
            !options.preview &&
            options.previewRequestParam) {
            this.preview =
                new URLSearchParams(window.location.search).get('preview') != null;
        }
    }
    getDealer(id) {
        return this.options.dealers[id];
    }
    getDealerPageOwner() {
        return this.currentPageOwner;
    }
    subscribe(listener) {
        this.listeners.push(listener);
        return () => {
            const index = this.listeners.indexOf(listener);
            if (index > -1) {
                this.listeners.splice(index, 1);
            }
        };
    }
}
exports.MyDealerConfigurationServiceV1Impl = MyDealerConfigurationServiceV1Impl;
//# sourceMappingURL=MyDealerConfigurationServiceV1Impl.js.map